import { create } from "zustand";

type AdjustmentStore = {
    isListAvailable: boolean;
    setListAvailable: (status: boolean) => void;
};

export const useAdjustmentStore = create<AdjustmentStore>((set) => ({
    isListAvailable: false,
    setListAvailable: (status: boolean) => set(() => ({ isListAvailable: status })),
}));
  